import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const BabyBottleOutline = createIcon({
  displayName: 'BabyBottleOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g transform="matrix(1 0 0 1 12.725 -3.221)">
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.141 7.092h2.219l-6.04959e-09 2.72848e-12c2.45104-.00110457 4.43889 1.98496 4.44 4.436 3.00504e-07.000666817 4.50723e-07.00133363 4.50656e-07.00200045v5.547 0c0 1.838-1.49 3.328-3.328 3.328h-4.44l6.71875e-08-8.07532e-11c-1.838.00220918-3.32979-1.486-3.332-3.324 -1.60355e-06-.00133413-2.40486e-06-.00266826-2.40393e-06-.0040024v-5.547l-6.4837e-14-3.43851e-07c-3.70097e-07-2.45104 1.98696-4.438 4.438-4.438 .00100034-1.51047e-10.00200068 3.37917e-07.00300101 1.0142e-06Z"
          transform="matrix(.707107 .707107 -.707107 .707107 0 0)"
        ></path>
      </g>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <line x1="15.89" x2="14.6" y1="14.68" y2="13.4"></line>
        <line x1="14.17" x2="12.25" y1="17.67" y2="15.75"></line>
        <line x1="11.82" x2="9.9" y1="20.02" y2="18.1"></line>
        <path d="M20.449 3.551v0l-3.3506e-08-3.35267e-08c-.733569-.734022-1.92329-.734389-2.65731-.000820549 -.073315.0732697-.140442.15248-.200693.236821l-.291.413 -1.27178e-08 1.77601e-08c-.178457.249211-.525151.306569-.774363.128112 -.0247973-.017757-.0480886-.0375279-.0696374-.0591117v0l1.81376e-08 1.81774e-08c-.826614-.828427-2.16829-.829897-2.99672-.0032833 -.00109562.00109322-.00219004.00218764-.00328326.00328326l-.856.851 -5.96794e-08 5.97385e-08c-.432964.433393-.432964 1.13561 1.19359e-07 1.569l4.711 4.711 5.03742e-08 5.03243e-08c.433393.432964 1.13561.432964 1.569-1.00649e-07l.856-.856 -8.37445e-08 8.35612e-08c.828427-.826614.829897-2.16829.00328343-2.99672 -.00109322-.00109562-.00218764-.00219004-.00328326-.00328326v0l-3.34086e-08-3.33543e-08c-.216917-.216565-.217202-.567971-.000637367-.784888 .0215488-.0215839.0448402-.0413547.0696374-.0591117l.408-.291 -4.78767e-08 3.42022e-08c.844408-.603229 1.03992-1.77677.436693-2.62118 -.0602513-.0843405-.127378-.163551-.200693-.236821Z"></path>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const BabyBottleTwoTone = createIcon({
  displayName: 'BabyBottleTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <Box
          as="g"
          strokeLinecap="round"
          strokeWidth="1.5"
          stroke="currentColor"
          fill="twoToneFillColor"
          strokeLinejoin="round"
        >
          <Box as="line" stroke="twoToneFillColor" x1="15.89" x2="14.6" y1="14.68" y2="13.4"></Box>
          <Box as="line" stroke="twoToneFillColor" x1="14.17" x2="12.25" y1="17.67" y2="15.75"></Box>
          <Box as="line" stroke="twoToneFillColor" x1="11.82" x2="9.9" y1="20.02" y2="18.1"></Box>
          <path d="M20.449 3.551v0l-3.3506e-08-3.35267e-08c-.733569-.734022-1.92329-.734389-2.65731-.000820549 -.073315.0732697-.140442.15248-.200693.236821l-.291.413 -1.27178e-08 1.77601e-08c-.178457.249211-.525151.306569-.774363.128112 -.0247973-.017757-.0480886-.0375279-.0696374-.0591117v0l1.81376e-08 1.81774e-08c-.826614-.828427-2.16829-.829897-2.99672-.0032833 -.00109562.00109322-.00219004.00218764-.00328326.00328326l-.856.851 -5.96794e-08 5.97385e-08c-.432964.433393-.432964 1.13561 1.19359e-07 1.569l4.711 4.711 5.03742e-08 5.03243e-08c.433393.432964 1.13561.432964 1.569-1.00649e-07l.856-.856 -8.37445e-08 8.35612e-08c.828427-.826614.829897-2.16829.00328343-2.99672 -.00109322-.00109562-.00218764-.00219004-.00328326-.00328326v0l-3.34086e-08-3.33543e-08c-.216917-.216565-.217202-.567971-.000637367-.784888 .0215488-.0215839.0448402-.0413547.0696374-.0591117l.408-.291 -4.78767e-08 3.42022e-08c.844408-.603229 1.03992-1.77677.436693-2.62118 -.0602513-.0843405-.127378-.163551-.200693-.236821Z"></path>
        </Box>
        <g transform="matrix(1 0 0 1 12.725 -3.221)">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9.141 7.092h2.219l-6.04959e-09 2.72848e-12c2.45104-.00110457 4.43889 1.98496 4.44 4.436 3.00504e-07.000666817 4.50723e-07.00133363 4.50656e-07.00200045v5.547 0c0 1.838-1.49 3.328-3.328 3.328h-4.44l6.71875e-08-8.07532e-11c-1.838.00220918-3.32979-1.486-3.332-3.324 -1.60355e-06-.00133413-2.40486e-06-.00266826-2.40393e-06-.0040024v-5.547l-6.4837e-14-3.43851e-07c-3.70097e-07-2.45104 1.98696-4.438 4.438-4.438 .00100034-1.51047e-10.00200068 3.37917e-07.00300101 1.0142e-06Z"
            transform="matrix(.707107 .707107 -.707107 .707107 0 0)"
          ></path>
        </g>
      </Box>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const BabyBottle: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={BabyBottleTwoTone} {...props} />
  default:
    return <CustomIcon as={BabyBottleOutline} {...props} />
  }
}

export default memo(BabyBottle)
